import { HierarchyUtils } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';

/**
 * Remove all children of certain product type from target (selected entity)
 */

const removeTypeFromTarget = (productType: string) => ({ coreApi }: BehaviorParameters) => {
  const target = coreApi.entities.findSelectedEntity();

  if (!target) return;

  const currentlyAtTarget = HierarchyUtils.children(target).filter(
    d => coreApi.entities.getProductType(d) === productType
  );

  currentlyAtTarget.forEach(entity => coreApi.entities.delete(entity));
};

export default removeTypeFromTarget;
